import React, {useRef} from "react";
import {observer} from "mobx-react-lite";
import {SequenceStateStore, SequenceUserClip} from "../store/SequenceStateStore";
import {TRACK_CLASSNAME} from "../config/constants";
import {SequenceApplicationStore} from "../store/SequenceApplicationStore";
import SequenceAudioClip from "../clips/SequenceAudioClip";
import SequenceVideoClip from "../clips/SequenceVideoClip";
import SequenceImageClip from "../clips/SequenceImageClip";

interface TrackLaneProps {
  layerId: string;
  pixelsPerSecond?: number;
  children?: React.ReactNode;
}

export const TrackLane: React.FC<TrackLaneProps> = observer(({ layerId, children }) => {
    const placeholderRef = useRef<HTMLDivElement>(null);
    // const createDropClipPlaceholder = useCreateDropClipPlaceholder(() => placeholderRef.current);

    const layer = SequenceStateStore.layers[layerId];
    // const temporaryTransitions = layer ? TimelineService.getTemporaryTransitions(layerId) : [];
    const clipsIds = layer ? layer.clipIds : []
    const transitionIds = [];
    const clips = clipsIds.reduce<Record<string, SequenceUserClip>>((acc, cv) => {
        acc[cv] = SequenceStateStore.clips[cv];
        return acc;
    }, {});

    const isScriptLayer = true;
    let layerHasWideClip = false;
    for (const [id, clip] of Object.entries(clips) as [string, SequenceUserClip][]) {
        if (clip.type === "audio" || clip.type === "video") {
            layerHasWideClip = true;
        }
    }

    // Taller track to accommodate words strip (16px) + waveform area
    const trackHeight = "5.5rem";

    const handleDrop = async (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();

        // @ts-ignore
        // createDropClipPlaceholder.onDragLeave(event);
        let librettoClipId = null;
        try {
            const draggingObject = SequenceApplicationStore.draggingObject;
            let clipId: string | undefined;

            if (!draggingObject) {
                return null;
            }

            if (draggingObject.type === "media") {
                // const mediaId = draggingObject.payload.id;
                // const startTime = convertUnitsToTime(event.nativeEvent.offsetX);
                // const clip = await RendleyService.addMediaToLayer(layerId, mediaId, startTime);
                // librettoClipId = clip.getCustomData(CLIP_LIBRETTO_CLIP_ID) as string;
                // if (librettoClipId === null || librettoClipId === "" || librettoClipId === undefined) {
                //     librettoClipId = GenerateLibrettoClipId();
                //     clip.setCustomData(CLIP_LIBRETTO_CLIP_ID, librettoClipId);
                //     RendleyStore.addClipIdForLibrettoClip(librettoClipId, clip.id);
                //     RendleyStore.setLayerIdForLibrettoClip(librettoClipId, layer.id);
                //     RendleyStore.addLibrettoClipIdToLayer(librettoClipId, layer.id);
                // }
                // clipId = clip?.id;
            }

            if (draggingObject.type === "text-preset") {
                // const title = draggingObject.payload;
                // const startTime = convertUnitsToTime(event.nativeEvent.offsetX);
                // const clip = await RendleyService.createLottieClip({
                //     dataUrl: title.dataUrl,
                //     propertiesUrl: title.propertiesUrl,
                //     startTime,
                //     layerId: layerId,
                // });
                // librettoClipId = clip.getCustomData(CLIP_LIBRETTO_CLIP_ID) as string;
                // if (librettoClipId === null || librettoClipId === "" || librettoClipId === undefined) {
                //     librettoClipId = GenerateLibrettoClipId();
                //     clip.setCustomData(CLIP_LIBRETTO_CLIP_ID, librettoClipId);
                //     RendleyStore.addClipIdForLibrettoClip(librettoClipId, clip.id);
                //     RendleyStore.setLayerIdForLibrettoClip(librettoClipId, layer.id);
                //     RendleyStore.addLibrettoClipIdToLayer(librettoClipId, layer.id);
                // }
                // clipId = clip?.id;
            }

            if (clipId != null) {
                SequenceApplicationStore.setSelectedClipId(clipId);
            }
        } catch {
            return null;
        }
    };

    const ReadableClipType = (clipType: string) => {
        return String(clipType).toLowerCase();
    }


    const renderClip = (clipId: string, index: number) => {
        const clip = clips[clipId];
        if (!clip) return null;

        switch (ReadableClipType(clip.type)) {
            case "audio":
                return <SequenceAudioClip key={clipId} clipId={clip.id} layerId={layerId} />;
            case "video":
                return <SequenceVideoClip key={clipId} clipId={clip.id} layerId={layerId} />;
            case "image":
                return <SequenceImageClip key={clipId} clipId={clip.id} layerId={layerId} />;
            default:
                return null;
        }
    };


    // const renderTransition = (transitionId: string) => {
    //     return <Transition key={transitionId} type="permanent" permanentTransition={{ transitionId }} />;
    // };
    //
    // const renderTransitionPlaceholder = ({ startTime, layerId, clipId }: any) => {
    //     return <Transition key={startTime} type="temporary" temporaryTransition={{ startTime, layerId, clipId }} />;
    // };

    const handleDragEnter = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        // @ts-ignore
        return createDropClipPlaceholder.onDragEnter(event);
    };

    const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        // @ts-ignore
        return createDropClipPlaceholder.onDragOver(event);
    };

    const handleDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.stopPropagation();
        // @ts-ignore
        return createDropClipPlaceholder.onDragLeave(event);
    };

    return (
        <div id={layerId} className={`${TRACK_CLASSNAME} ${TRACK_CLASSNAME}-${layerId}`}>
            <div
                className="track__content"
                onDragEnter={handleDragEnter}
                onDragOver={handleDragOver}
                style={{ height: trackHeight}}
                onDrop={handleDrop}
                onDragLeave={handleDragLeave}
                onMouseDown={(e) => {
                    // Deselect when clicking empty track space (not on a clip)
                    if (e.currentTarget === e.target) {
                        SequenceApplicationStore.clearClipSelection();
                    }
                }}
            >
                <div ref={placeholderRef} className="track__drop-clip-placeholder"></div>
                {clipsIds.map(renderClip)}
                {children}
                {/*{transitionIds.map(renderTransition)}*/}
                {/*{temporaryTransitions.map(renderTransitionPlaceholder)}*/}
            </div>
        </div>
    );
});
